import { render, staticRenderFns } from "./TablePage.vue?vue&type=template&id=50b990e5&scoped=true"
import script from "./TablePage.vue?vue&type=script&lang=js"
export * from "./TablePage.vue?vue&type=script&lang=js"
import style0 from "./TablePage.vue?vue&type=style&index=0&id=50b990e5&prod&lang=scss&scoped=true"
import style1 from "./TablePage.vue?vue&type=style&index=1&id=50b990e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b990e5",
  null
  
)

export default component.exports